import { cB as e, c as i } from "../../../../_utils/cssr/index.js";
const l = e("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
`, [i("svg", `
 height: 1em;
 width: 1em;
 `)]);
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/icon/src/styles/index.cssr.js
// module id = 1537
// module chunks = 41